import { mmvFields } from 'mmv/inquiry/fields';
import { fieldValidators } from 'modules/Inquiry/inquiryFieldValidation/customValidations';

export const mmvFinancingObjectValidationMap = {
  [mmvFields.contractDetails.financingObjectSection.serialNumber]: fieldValidators
    .string()
    .max(50)
    .optional(),
};
